"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../theme");

var _emotion = require("emotion");

var _buttonReset = _interopRequireDefault(require("./../_styles/button-reset"));

var _tag = _interopRequireDefault(require("@amzn/meridian-tokens/component/tag"));

var _token = require("./../_utils/token");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _indicator = _interopRequireDefault(require("./indicator"));

/**
 * Styles
 */
// HACK: This is necessary to keep IE11 from allowing the tag's text to overflow
// the boundaries of the tag. When we drop IE11 support this wrapper can be
// removed and the "display" property of the styles below can be changed from
// "flex" to "inline-flex".
var wrapperStylesForIE11 = (0, _emotion.css)({
  display: "inline-block"
});
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      children = _ref.children;
  return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: t("height"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  }, children === undefined ? {
    width: t("height")
  } : {
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderStyle: "solid",
    borderColor: t("borderColorStatus", type),
    paddingRight: t("spacingInsetStatusRight"),
    paddingLeft: t("spacingInsetStatusLeft")
  });
}, ["type", "children"]);
/**
 * Component
 */

var StatusTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  var compact = typeof props.children === "undefined" ? true : false;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStylesForIE11,
    ref: ref,
    "aria-label": props["aria-label"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  }, /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
    type: props.type,
    compact: compact
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.children)));
});

StatusTag.displayName = "StatusTag";
StatusTag.propTypes = process.env.NODE_ENV !== "production" ? {
  "aria-label": _propTypes["default"].string,
  children: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
StatusTag.defaultProps = {
  type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;